export default __webpack_public_path__ + "static/media/EasterDay_13.3eeb7a25.png";